import { getNumber, lazyWithRetry } from '@tyro/core';
import { PersonGearIcon } from '@tyro/icons';
import { type NavObjectFunction, NavObjectType } from '@tyro/router/types';
import { getAdminPartyPeople } from './api/party-people';
import { getTenants } from './api/tenants';

const AdminSchoolsPage = lazyWithRetry(() => import('./pages/school'));
const AdminPeoplesPage = lazyWithRetry(() => import('./pages/school/people'));
const GraphiQLPage = lazyWithRetry(() => import('./pages/graphiql'));
const AdminPermissionsPage = lazyWithRetry(() => import('./pages/permissions'));

export const getRoutes: NavObjectFunction = (t) => [
  {
    type: NavObjectType.Category,
    title: t('navigation:management.title'),
    children: [
      {
        type: NavObjectType.RootGroup,
        path: '/admin',
        icon: <PersonGearIcon />,
        title: t('navigation:general.admin.title'),
        children: [
          {
            type: NavObjectType.MenuLink,
            title: t('navigation:general.admin.schools'),
            path: 'schools',
            hasAccess: ({ permissions }) => permissions.isTyroTenantAndUser,
            loader: () => getTenants(),
            element: <AdminSchoolsPage />,
          },
          {
            type: NavObjectType.NonMenuLink,
            path: 'schools/:schoolId',
            hasAccess: ({ permissions }) => permissions.isTyroTenantAndUser,
            loader: ({ params }) => {
              const schoolId = getNumber(params?.schoolId);
              return getAdminPartyPeople(schoolId);
            },
            element: <AdminPeoplesPage />,
          },
          {
            type: NavObjectType.MenuLink,
            title: t('navigation:general.admin.permissions'),
            path: 'permissions',
            hasAccess: ({ permissions }) => permissions.isTyroUser,
            element: <AdminPermissionsPage />,
          },
          {
            type: NavObjectType.MenuLink,
            title: t('navigation:general.admin.graphiql'),
            path: 'graphiql',
            hasAccess: ({ permissions }) =>
              permissions.isTyroUser || process.env.NODE_ENV !== 'production',
            element: <GraphiQLPage />,
          },
        ],
      },
    ],
  },
];
